export enum PurchaseReason {
  CANCEL_ACCOUNT = 'CANCEL_ACCOUNT',
  LIMIT = 'LIMIT',
  ERROR = 'ERROR',
}
